import { motion } from "framer-motion";
import { useEffect, useRef, useState } from "react";
import { Search } from "lucide-react";
import NavBar from "../../components/Navigation/NavBar";
import Footer from "../../components/Footer/Footer";
import Vertical_1 from '../../assests/images/vertical_1.jpg'
import Vertical_2 from '../../assests/images/vertical_2.jpg'
import Horizontal_1 from '../../assests/images/horizontal_1.jpg'
import Horizontal_2 from '../../assests/images/horizontal_2.jpg'
import Horizontal_3 from '../../assests/images/horizontal_3.jpeg'
import Horizontal_4 from '../../assests/images/horizontal_4.jpg'
import Horizontal_5 from '../../assests/images/horizontal_5.jpg'
import Horizontal_6 from '../../assests/images/horizontal_6.jpeg'
import Horizontal_7 from '../../assests/images/horizontal_7.jpeg'
import SecondSection from "../../components/Mentorship/SecondSection";
import ThirdSection from "../../components/Mentorship/ThirdSection";
import FourthSection from "../../components/Mentorship/FourthSection";
import FifthSection from "../../components/Mentorship/FifthSection";
import SixthSection from "../../components/Mentorship/SixthSection";
import SeventhSection from "../../components/Mentorship/SeventhSection";
import { useParams } from "react-router-dom";
import { Helmet } from "react-helmet";
import Logo from '../../assests/navLogo.png'
import { ReactComponent as ConferenceSVG } from "../../assests/svg/conference.svg";
import { ReactComponent as ConnectionSVG } from "../../assests/svg/connection.svg";
import PartnersOrbit from "../../components/Parnters/PartnersOrbit";






export default function LandingPage() {
  const [displayText, setDisplayText] = useState("");
  const fullText = "NextLoop Gateway";
  const sixthSectionRef = useRef(null);
  const thirdSectionRef = useRef(null);

  const scrollToSixthSection = () => {
    sixthSectionRef.current?.scrollIntoView({ behavior: "smooth" });
  };

  const scrollToThirdSection = () => {
    thirdSectionRef.current?.scrollIntoView({ behavior: "smooth" });
  };

  useEffect(() => {
    let i = 0;
    const typing = setInterval(() => {
      setDisplayText(fullText.slice(0, i + 1));
      i++;
      if (i === fullText.length) clearInterval(typing);
    }, 40);
    return () => clearInterval(typing);
  }, []);

  useEffect(() => {
    document.title = "Nextloop Gateway";
  }, []);

  return (
    <>
      <NavBar></NavBar>
      <section className="relative bg-[#FFFAFA]-950">

        <section className="relative bg-[#FFFAFA]-950 text-white min-h-screen flex flex-col justify-between px-6 md:px-12 lg:px-16 py-12 overflow-hidden">
          <div
            className="absolute inset-0 pointer-events-none"
            style={{
              background: `
      radial-gradient(circle at 0% 0%, rgba(50,98,144,0.45), transparent 65%),
      radial-gradient(circle at 100% 100%, rgba(50,98,144,0.35), transparent 70%)
    `,
            }}
          />
          {/* TOP CONTENT */}
          <div className="flex flex-col lg:flex-row items-start justify-between gap-10 lg:gap-12">

            {/* LEFT TEXT */}
            <motion.div
              initial={{ opacity: 0, y: 20 }}
              animate={{ opacity: 1, y: 0 }}
              transition={{ duration: 0.7, ease: "easeOut" }}
              className="max-w-3xl mt-10 md:mt-16 lg:mt-20"
            >
              <h1 className="text-4xl md:text-6xl lg:text-7xl font-bold leading-tight text-gray-900">
                {displayText}
              </h1>

              <p className="text-gray-600 text-sm pt-4">
                From spotlight to handshakes
              </p>

              <p className="text-gray-600 text-sm pt-4">
                Converting global stakeholders, enabling cross-sector collaboration, and turning conversations into lasting partnerships.
              </p>

              <p className="text-gray-600 text-sm pt-4">
                NextLoop Gateway connects the world to Singapore, where global handshakes happen.
              </p>

              <p className="text-gray-600 text-sm pt-4">
                Powered by institutional partnerships, NextLoop's Ecosystem has reached decision-makers across 150+ organisations and over 10,000 individuals who have experienced NextLoop firsthand, our ecosystem turns products, services, and community engagement into real connections that matter.
              </p>
            </motion.div>

            {/* RIGHT STATS + SEARCH */}
            {/* <motion.div
              initial={{ opacity: 0, x: 40 }}
              animate={{ opacity: 1, x: 0 }}
              transition={{ duration: 0.8, delay: 0.2, ease: "easeOut" }}
              className="flex flex-col gap-4 w-full max-w-lg mt-6 md:mt-12 lg:mt-20"
            >
              <div className="flex justify-center text-center gap-6 md:gap-0 md:justify-between">
                <div>
                  <h3 className="text-2xl font-bold">100+</h3>
                  <p className="text-gray-400 text-sm">Events</p>
                </div>
                <div>
                  <h3 className="text-2xl font-bold">85%</h3>
                  <p className="text-gray-400 text-sm">achieve their professional goals</p>
                </div>
                <div>
                  <h3 className="text-2xl font-bold">750+</h3>
                  <p className="text-gray-400 text-sm">available mentors</p>
                </div>
              </div>


              <p className="text-gray-400 text-sm mt-2">
                Explore a diverse network of professionals eager to share expertise and support you.
              </p>

          
            </motion.div> */}

            <motion.div
              initial={{ opacity: 0, x: 40 }}
              animate={{ opacity: 1, x: 0 }}
              transition={{ duration: 0.8, delay: 0.2, ease: "easeOut" }}
              className="hidden lg:flex flex-col gap-4 w-full max-w-lg mt-6 md:mt-12 lg:mt-20"
            >
              <div className="flex justify-center text-center gap-6 md:gap-0 md:justify-between">
                {/* <ConnectionSVG className="w-full h-[140px] md:h-[275px] transition-transform duration-500"
                  aria-label="mentor illustration" /> */}
                  <img
                loading="lazy"
                src={Horizontal_6}
                alt="mentor"
                className="w-full h-[180px] md:h-[280px] object-cover rounded-[24px] hover:scale-105 transition-transform duration-500"
              />
              </div>


            </motion.div>

          </div>

          {/* BOTTOM MOSAIC GRID */}
          <motion.div
            initial={{ opacity: 0, y: 40 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.8, delay: 0.3, ease: "easeOut" }}
            className="grid grid-cols-1 md:grid-cols-12 md:gap-4 mt-12 md:mt-16"
          >

            {/* Large vertical image */}
            <div className="mb-4 md:flex md:col-span-5 lg:col-span-4 rounded-[28px] overflow-hidden">
              <img
                loading="lazy"
                src={Vertical_1}
                alt="mentor"
                className="w-full b-4 h-[240px] md:h-[375px] object-cover hover:scale-105 transition-transform duration-500"
              />

              {/* <ConferenceSVG
                className="w-full h-[240px] md:h-[375px] transition-transform duration-500"
                aria-label="mentor illustration"
              /> */}


            </div>

            {/* Text cards */}
            <div className="col-span-1 md:col-span-7 lg:col-span-8 flex flex-col gap-4">
              <div className="bg-gray-900 rounded-2xl p-5">
                <h3 className="text-lg font-semibold text-white">
                  The World is Changing. Are You Ready to Lead It?
                </h3>
                <p className="text-gray-400 text-sm mt-2">
                  The future you imagined was never guaranteed. Now is your chance to shape it.
                </p>
                {/* <div className="flex justify-end mt-4">
                  <button className="p-2 bg-gray-800 rounded-full hover:bg-gray-700 transition">
                    →
                  </button>
                </div> */}
              </div>

              <div className="bg-gray-900 rounded-2xl p-6">
                <h3 className="text-lg font-semibold mb-2 text-white">
                  Opportunities won't wait. Will you?
                </h3>
                <p className="text-gray-400 text-sm">
                  NextLoop Gateway is your platform to connect, collaborate, and set the agenda for tomorrow.
                </p>
              </div>
            </div>

            {/* <div className="hidden md:flex md:col-span-3 rounded-[28px] overflow-hidden"> */}
            {/* <img
                loading="lazy"
                src={Vertical_1}
                alt="mentor"
                className="w-full h-[240px] md:h-[375px] object-cover hover:scale-105 transition-transform duration-500"
              /> */}


            {/* </div> */}

            {/* Horizontal images */}
            {/* <div className="hidden md:flex md:col-span-6 flex-col gap-4 lg:col-span-4">
              <img
                loading="lazy"
                src={Horizontal_6}
                alt="mentor"
                className="w-full h-[180px] md:h-[180px] object-cover rounded-[24px] hover:scale-105 transition-transform duration-500"
              />
              <img
                loading="lazy"
                src={Horizontal_7}
                alt="mentor"
                className="w-full h-[180px] md:h-[180px] object-cover rounded-[24px] hover:scale-105 transition-transform duration-500"
              />
            </div> */}


            {/* Tall right image */}
            {/* <div className="md:col-span-3 rounded-[24px] overflow-hidden lg:col-span-2">
              <img
                loading="lazy"
                src={Vertical_2}
                alt="mentor"
                className="w-full h-[260px] md:h-[375px] object-cover rounded-[24px] hover:scale-105 transition-transform duration-500"
              />
            </div> */}

          </motion.div>

        </section>

        <SecondSection onRegisterInterest={scrollToSixthSection} />
        {/* <ThirdSection ref={thirdSectionRef} /> */}
        <FourthSection />
        {/* <FifthSection /> */}
        <SixthSection ref={sixthSectionRef} onExploreEvents={scrollToThirdSection} />
        {/* <SeventhSection/> */}

        <PartnersOrbit
/>

      </section>
      <Footer></Footer>
    </>
  );
}
